import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DeliverySelection = ({
  changeDeliveryOptions,
  deliveryOptions,
  selectedDeliveryOptions,
  products,
  outOfStockDeliveryOptions,
}) => {
  return (
    <div
      className={classNames('flex-wrap delivery-selection delivery-more-items')}>
      {deliveryOptions.map((option, i) => {
        const available =
          products &&
          products.some((product) =>
            product.delivery_options.some((id) => id == option.key)
          );
        const outOfStock =
          outOfStockDeliveryOptions &&
          outOfStockDeliveryOptions.some((oosOption) => oosOption.key === option.key);
        const unavailable = !available || outOfStock;
        const isSingleOption = deliveryOptions.length <= 1;
        const deliveryIcon = `icon__${option.type?.toLowerCase()}`;

        return (
          <div
            className={classNames(
              'delivery w-80 ml-2 flex-wrap align-more-items mb-2'
            )}
            key={i}>
            <div
              className={classNames(
                'delivery-option rounded d-flex flex-column',
                {
                  selected: option.key === parseInt(selectedDeliveryOptions),
                  disabled: unavailable,
                  button: !isSingleOption,
                },
              )}
              onClick={() => changeDeliveryOptions(option.key)}>
              <i
                className={`fa ${deliveryIcon} fa-lg ${unavailable && 'disabled'} ${!isSingleOption && 'selectable'}`}
                data-test-id="deliveryIcon"></i>
              <p
                className={classNames('delivery-text', {
                  disabled: unavailable && !outOfStock,
                  'oos-unavailable': outOfStock,
                })}>
                {option.mobile_title}
              </p>
              {outOfStock && (
                <p className="delivery-text oos-unavailable-red disabled">Unavailable</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

DeliverySelection.propTypes = {
  changeDeliveryOptions: PropTypes.func.isRequired,
  deliveryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      mobile_title: PropTypes.string,
    }),
  ).isRequired, // Enforce required array of objects with specific shapes
  selectedDeliveryOptions: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  products: PropTypes.arrayOf(PropTypes.object),
  isMoreOptions: PropTypes.bool,
  outOfStockDeliveryOptions: PropTypes.arrayOf(PropTypes.object),
};

export default DeliverySelection;
